export type Theme = "dark" | "light";

const THEME_KEY = "rigel.theme";
const THEME_COLOR_DARK = "#0b0d12";
const THEME_COLOR_LIGHT = "#fafafa";

export function detectTheme(): Theme {
  const stored = localStorage.getItem(THEME_KEY);
  if (stored === "dark" || stored === "light") return stored;
  return window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
}

export function applyTheme(t: Theme) {
  document.documentElement.dataset.theme = t;
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", t === "dark" ? THEME_COLOR_DARK : THEME_COLOR_LIGHT);
}

export function persistTheme(t: Theme) {
  localStorage.setItem(THEME_KEY, t);
}

export function toggleTheme(current: Theme): Theme {
  return current === "dark" ? "light" : "dark";
}
